import { render, staticRenderFns } from "./TermsAgreement.vue?vue&type=template&id=23844888&scoped=true&"
import script from "./TermsAgreement.vue?vue&type=script&lang=js&"
export * from "./TermsAgreement.vue?vue&type=script&lang=js&"
import style0 from "./TermsAgreement.vue?vue&type=style&index=0&id=23844888&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23844888",
  null
  
)

export default component.exports